import { GET_CONFIG, SET_SIGNALR_GROUPS } from '../actionTypes';
/**
 * action for load config
 * @param result
 * @returns
 */
export function getConfig(data: any) {
  return {
    type: GET_CONFIG,
    data,
  };
}
/**
 *
 * Set intial Groups/channels to SignalR
 * @param data
 * @returns
 */
export function setSignalRGroups(data: any) {
  return {
    type: SET_SIGNALR_GROUPS,
    data,
  };
}
